// extracted by mini-css-extract-plugin
module.exports = {"popoverContainer":"pop-over-menu_popoverContainer__2huwz","content":"pop-over-menu_content__PlUj-","icon":"pop-over-menu_icon__Zxn3I"};